'use strict';
const angular = require('angular');

export class issuedToChangeFormComponent {

  constructor($uibModal, VendorService) {
    'ngInject';
    this.$uibModal = $uibModal;

    VendorService.query(data => {
      this.vendors = data.map(vendor => {
        return {
          value: vendor._id,
          name: vendor.name,
          type: vendor.type
        };
      });
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.data.issuedTo)
      this.issuedTo = this.config.data.issuedTo._id;
  };

  vendorLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'vendorLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (vendor) {
        that.selectedVendor = vendor;
        that.issuedTo = vendor._id;
      },
      function () { /* cancel */ }
    );

  }

  ok() {
    this.close({$value: {
      issuedTo: this.issuedTo,
      note: this.note
    }});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.issuedToChangeForm', [])
  .component('issuedToChangeForm', {
    template: require('./issued-to-change-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: issuedToChangeFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/issued-to-change-form/issued-to-change-form.component.js